import { firebase } from './index'

let analytics

const isProd = window.location.host === 'app.xerpa-md.com'

if (isProd) {
  analytics = firebase.analytics()
}

export function logEvent(eventName) {
  const EVENTS = {
    CLINICAL_LOG_SUBMISSION: 'clinical_log_submission',
    TRAINING_LOG_SUBMISSION: 'training_log_submission',
    SCIENTIFIC_LOG_SUBMISSION: 'scientific_log_submission'
  }
  const event = EVENTS[eventName]
  if (event && analytics) {
    analytics.logEvent(event)
  }
}

export function setUserProperty(_prop, value) {
  const PROPS = {
    SPECIALTY: 'specialty'
  }

  const prop = PROPS[_prop]

  if (prop && analytics) {
    analytics.setUserProperties({ [prop]: value })
  }
}
